import { ClientPortalBlockFieldMappingModel } from '../../../../shared/models';
import { PropertyMapping } from '../../../../shared/properties';

export const matchFieldMapping =
  ({ mapping }: { mapping: PropertyMapping }) =>
  (field: { mapping: PropertyMapping }): boolean =>
    (
      ['entity', 'type', 'key'] as (keyof ClientPortalBlockFieldMappingModel)[]
    ).every((key) => field?.mapping?.[key] === mapping?.[key]);
